import { Container, Row, Col, Card, Image } from 'react-bootstrap'
import { ArrowRightCircle } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import headerImg from '../../assets/logos/TMLogo.png'

import { fetchWrapper } from '_helpers/fetch-wrapper'

export const NextMeeting = (homePageData) => {

  const [isLoading, setIsLoading] = useState(true, [])
  const [meeting, setMeeting] = useState(true, [])

  const url = process.env.REACT_APP_URL

  const getMeetings = async () => {
    setIsLoading(true)
    try {
      const response = await fetchWrapper.get(`${url}/meetings/comingup`)
      setMeeting(response)
      // console.log('response', response)
    }
    catch (e) {
      console.log('Next meeting: ' + e)
    }
    // console.log(meeting)
    setIsLoading(false)
  }

  const toastmaster = meeting.roleAssignments?.find(
    (assignment) => assignment.role.name === "Toastmaster"
  )?.user
  // console.log('toastmaster', toastmaster)
  const meetingTitle = (meeting.imageUrl === '' || meeting.imageUrl === 'undefined' || !meeting.imageUrl) ? meeting.meetingTheme : ''

  useEffect(() => {
    getMeetings()
    // eslint-disable-next-line
  }, [])

  const cardBackground = <>
    <Row className="card-bg">
      <Col>

        {!toastmaster?.avatar
          ? '' :
          <>
            <Row className='justify-content-center'>
              <Col className='hexagon'>
                <Image src={'data:image/png;base64,' + toastmaster?.avatar} />
              </Col>
              <Col className='logo'>
                <Image src={headerImg} alt="Toastmasters Logo" />
              </Col>
            </Row>
          </>
        }
        <h3 className='not-found-title'>{meetingTitle}</h3>
        {/* <h6 className='not-found-details float-left'>#{meeting.meetingNumber} - {meeting.meetingDate} - {meeting.meetingType} MEETING</h6> */}
      </Col>
    </Row>
  </>

  return (
    <section className="nextMeeting" id="nextMeeting">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={6}>
            <Row>
              <Col>
                {homePageData.homePageData.nextMeeting.title?.visible && <span className="bold"><h2>{homePageData.homePageData.nextMeeting.title.text}</h2></span>}
                {homePageData.homePageData.nextMeeting.description?.visible && <div dangerouslySetInnerHTML={{ __html: homePageData.homePageData.nextMeeting.description.text }}></div>}
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6} xl={6} >
            {(meeting) &&
              <Card className="text-center next-meeting card-bg" >
                {
                  (isLoading)
                    ?
                    <Spinner animation="border" variant="danger" />
                    :
                    <>
                      <Col xs={12} lg={12} >
                        {(meeting.imageUrl && meeting.imageUrl !== '' && meeting.imageUrl !== 'undefined') &&
                          <Card.Img variant="top" src={meeting?.imageUrl} alt="Meeting Background" />
                        }
                        {(!meeting.imageUrl || meeting.imageUrl === '' || meeting.imageUrl === 'undefined') &&
                          cardBackground
                        }
                      </Col>
                    </>
                }
                <div className='nextMeeting-overlay'>
                </div>
                {(meeting) && <Link to={(meeting._id === undefined) ? "/meetings/" : "/meeting/" + meeting._id} className='stretched-link'>{(meeting._id === undefined ? 'Open the meetings page' : 'Open the meeting agenda')} <ArrowRightCircle size={25} /></Link>}
              </Card>
            }
            <Row>
              <Col>
                <Link to={'/meetings'} >See all meetings <ArrowRightCircle size={25} /></Link>
              </Col>
            </Row>
          </Col>
        </Row>

      </Container>
    </section>
  )
}